import _ from "lodash";
import {
    SHOPIFY_PRODUCT_IMAGES_PATH
} from "../constants/shopify.constant";

export {
    applyProductImageFeaturedSettings,
    resetImagePosition,
}

const applyProductImageFeaturedSettings = (settings, productImageList) => {
    _.forEach(productImageList, (productImage, productImageIndex) => {
        prepareProductImageProps(productImage, settings, productImageIndex);
        // productImageFileName(productImage, productDetail, productImageIndex + 1);
    });
}

const productImageFileName = (productImage, productDetail, productImageIndex) => {
    const filePath = [];
    filePath.push(_.kebabCase(SHOPIFY_PRODUCT_IMAGES_PATH));
    filePath.push(_.kebabCase(productImage.productId));
    filePath.push(productDetail?.handle + '-' + productImageIndex + '-' + productImage.id + '.jpg');
    productImage.imageFilePath = _.join(_.compact(filePath), '/');
    productImage.imageIndex = productImageIndex;
}

const prepareProductImageProps = (productImage, settings, productImageIndex) => {
    const imageProps: any = {};
    imageProps.x = (productImageIndex * 100);
    imageProps.y = 0;

    const productConfig = settings.product;

    fitImage(productImage, imageProps, productConfig, settings, productImageIndex);
    imageProps.fillPatternRotation = productConfig.fillPatternRotation;
    imageProps.size = productConfig.size;
    imageProps.fillPatternOffsetXPercentage = productConfig.fillPatternOffsetXPercentage;
    imageProps.fillPatternOffsetYPercentage = productConfig.fillPatternOffsetYPercentage;

    console.log('imageProps', imageProps);
    console.log('productConfig', productConfig);

    productImage.props = imageProps;
}

const fitImage = (productImage, imageProps, productConfig, settings, productImageIndex) => {
    let fillPatternScale = settings?.height / productImage?.height;

    if (productConfig.fit === 'height') {
        fillPatternScale = settings?.height / productImage?.height;
    } else if (productConfig.fit === 'width') {
        fillPatternScale = settings?.width / productImage?.width;
    }

    imageProps.fillPatternScaleX = fillPatternScale;
    imageProps.fillPatternScaleY = fillPatternScale;
    imageProps.width = productImage?.width * fillPatternScale;
    imageProps.height = productImage?.height * fillPatternScale;

    if (productConfig.fit === 'width') {
        imageProps.y = (settings?.height - imageProps?.height) / 2;
    } else if (productConfig.fit === 'height') {
        // imageProps.x = (productImageIndex * 100);
        imageProps.x = (settings?.width - imageProps?.width) / 2;
        // imageProps.x = ((settings?.width - imageProps?.width) / 2) + (productImageIndex * 100);
    }

    imageProps.fillPatternOffsetX = -(imageProps.width * productConfig.fillPatternOffsetXPercentage / 100);
    imageProps.fillPatternOffsetY = (imageProps.height * productConfig.fillPatternOffsetYPercentage / 100);
}

const resetImagePosition = (productImage, settings) => {
    const imageProps: any = {};
    imageProps.x = 0;
    imageProps.y = 0;

    const productConfig = settings.product;
    fitImage(productImage, imageProps, productConfig, settings, 0);
    
    productImage.props = imageProps;
}
